import { StylePropertiesTypes } from '@wix/document-services-types'
import type { Spx } from '@wix/thunderbolt-becky-types'
import type { StylePropItem } from '@wix/thunderbolt-becky-root'
import { stylePropsToCssConverterMap } from '../utils/convertStyleProps'

/** Internal Converters */
const coordinatesConverter = (prop: StylePropertiesTypes.Coordinates<StylePropItem>, spx: Spx) => {
	const { left: leftProp, right: rightProp, top: topProp, bottom: bottomProp } = prop

	const left = leftProp && stylePropsToCssConverterMap[leftProp.type](leftProp, spx)
	const right = rightProp && stylePropsToCssConverterMap[rightProp.type](rightProp, spx)
	const top = topProp && stylePropsToCssConverterMap[topProp.type](topProp, spx)
	const bottom = bottomProp && stylePropsToCssConverterMap[bottomProp.type](bottomProp, spx)

	return {
		top,
		right,
		bottom,
		left,
		[prop.type]: `--var(--{propName}-top), --var(--{propName}-right), --var(--{propName}-bottom), --var(--{propName}-left)`,
	}
}

/** External Map */
export const genericsConverterMap = {
	Coordinates: coordinatesConverter,
}
